import SimpleCard from './Simple.vue';

export * from './types';
export default SimpleCard;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/simple/index.ts